import React, { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';

import teamList from '@/assets/team/team.json';

import getGravatarData from './gravatar';
import MemberCard from './MemberCard';

export default function TeamSection() {
    const [leaders, setLeaders] = useState([]);
    const [researchers, setResearchers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const enriched = await Promise.all(
                    teamList.map(async (member) => {
                        const data = await getGravatarData(
                            member.profileIdentifier
                        );
                        return {
                            ...member,
                            display_name: data?.display_name,
                            avatar_url: data?.avatar_url,
                            profile_url: data?.profile_url,
                        };
                    })
                );

                setLeaders(enriched.filter((member) => member.leader === true));
                setResearchers(
                    enriched.filter(
                        (member) =>
                            member.leader === false &&
                            (member.current ?? true) === true
                    )
                );
            } catch (error) {
                console.error('Failed to load team data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading team...</span>
                </div>
            </div>
        );
    }

    return (
        <section>
            <Container>
                <h2 className="text-primary mb-4 text-center">Meet the Team</h2>
                <Row className="g-4 justify-content-center">
                    {leaders.map((leader) => (
                        <MemberCard
                            key={leader.profileIdentifier || leader.name}
                            name={leader.display_name || leader.name}
                            avatarUrl={leader.avatar_url}
                            profileUrl={leader.profile_url}
                            title={leader.title}
                            university={leader.university}
                            bio={leader.bio}
                            size="leader"
                        />
                    ))}
                </Row>
                <h2 className="text-primary mt-5 mb-3 text-center">
                    Student Researchers
                </h2>
                <p className="text-center text-muted mb-4">
                    RILE Connect is built by C3 Lab student researchers at MSU
                    Denver. Meet the team behind the platform.
                </p>
                <Row className="g-4">
                    {researchers.map((researcher) => (
                        <MemberCard
                            key={
                                researcher.profileIdentifier || researcher.name
                            }
                            name={researcher.display_name || researcher.name}
                            avatarUrl={researcher.avatar_url}
                            profileUrl={researcher.profile_url}
                            title={researcher.title}
                            university={researcher.university}
                            size="researcher"
                        />
                    ))}
                </Row>
            </Container>
        </section>
    );
}
